export const FB_APP_ID = '2984588238479261';

export const MAP_DEFAULT_CENTER = {
    lat: 40.177583,
    lng: 44.512516
};

export const MAP_DEFAULT_ZOOM = 13;
